/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.1.5
 */

export type ReportsFindCoordinatesCategoryOfTest =
  (typeof ReportsFindCoordinatesCategoryOfTest)[keyof typeof ReportsFindCoordinatesCategoryOfTest];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsFindCoordinatesCategoryOfTest = {
  direct: 'direct',
  indirect: 'indirect',
  observation: 'observation',
  others: 'others',
} as const;
